function DeviceConfigurationPage() {
    /**
     *
     */
    DeviceConfigurationPage.prototype.initialize = function (console, device) {
        this.id = "deviceConfiguration";
        this.console = console;

        // Only at initialization

        this.console.deviceConfigurationScope = 0;

        if (device) {
            this.deviceId = device.id;
            this.device = this.console.consoleService
                .filterTransient(device);
            Device.bind(this.console.deviceTypes, this.console.node, this.device);
        }

        return this;
    };

    /**
     *
     */
    DeviceConfigurationPage.prototype.show = function () {
        var deferred = $.Deferred();

        this.console.nodeConfigurationScope = 0;

        deferred.resolve();

        return deferred.promise();
    };

    /**
     *
     */
    DeviceConfigurationPage.prototype.deviceTypeChanged = function () {
        this.device = Device.create(this.console.node, this.console.deviceTypes[this.plugin]);
    };

    /**
     *
     */
    DeviceConfigurationPage.prototype.createDevice = function () {
        this.console.createDevice(this.device).done(function () {
            this.console.popPage();
        }.bind(this)).fail(function (error) {
            this.console.openMessageDialog("Failed to add Device.", "error");
        }.bind(this));
    };

    /**
     *
     */
    DeviceConfigurationPage.prototype.updateDevice = function () {
        this.console.consoleService.updateDevice(this.device).done(function () {
            this.console.popPage();
        }.bind(this)).fail(function (error) {
            this.console.openMessageDialog("Failed to change Device.", "error");
        }.bind(this));
    };

    /**
     *
     */
    DeviceConfigurationPage.prototype.deleteActor = function (index) {
        this.console.openConfirmationDialog("You are going to delete Actor [" + this.device.actors[index].label + "]. Please confirm.", function () {
            this.device.actors.splice(index, 1);
        }.bind(this));
    };

    /**
     *
     */
    DeviceConfigurationPage.prototype.deleteSensor = function (index) {
        this.console.openConfirmationDialog("You are going to delete Sensor [" + this.device.sensors[index].label + "]. Please confirm.", function () {
            this.device.actors.splice(index, 1);
        }.bind(this));
    };

    /**
     *
     */
    DeviceConfigurationPage.prototype.leave = function () {
    };
}
